import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { queryClient } from "./lib/query-client";
import { initWebVitals } from "./lib/web-vitals";
import App from "./App.tsx";
import "./index.css";
import { NotificationProvider } from "./contexts/NotificationProvider.tsx";
import { UserProvider } from "./contexts/UserContext.tsx";

// Initialize Web Vitals tracking
initWebVitals();

createRoot(document.getElementById("root")!).render(
  <QueryClientProvider client={queryClient}>
    <UserProvider>
    <NotificationProvider>
      <App />
    </NotificationProvider>
    </UserProvider>
    <ReactQueryDevtools initialIsOpen={false} />
  </QueryClientProvider>
);
